<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">Copy Survey</h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Survey Packaging Name">
              <b-input
                expanded
                name="packaging_name"
                v-model="packaging_name"
                required
              ></b-input>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" type="is-normal" @click="cancel">
          Cancel
        </b-button>
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submit"
        >
          <span>Create a Copy</span>
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import RAMSurveyService from "@/services/RAMSurveyService";
// @group Dashboard
export default {
  name: "CopySurvey",

  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      customer: this.customerId,
      isModalActive: false,
      packaging_name: "",
      surveyService: new RAMSurveyService()
    };
  },
  mounted() {
    this.getPackingList();
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    getPackingList() {
      console.log("getPackingList called with customerId:", this.customerId);
      // this.surveyService.getPackingList(this.customerId).subscribe(response => {
      //   this.form = response;
      // }, this.handleApiError);
    },

    submit() {
      if (this.action == "Add") {
        this.surveyService
          .createSurveyProduct(this.customer, this.form)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "New Product is Added!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      } else if (this.action == "Update") {
        this.surveyService
          .updateSurveyProduct(this.customer, this.form)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Product is Updated!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      }
    },
    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.isDataLoading = false;
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    customerId(newValue) {
      this.customer = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
